import { useSyncExternalStore } from 'react';
import { Avatar } from '@mantine/core';
import { IconUser } from '@tabler/icons-react';

import { apiBaseUrl } from '@ayocore/platform/client/helpers/fetcher';
import { useAuthController } from '../useAuthController';
import { UsersController } from '../UsersController';

/**
 * Иконка профиля для dock-бара.
 * Показывает аватарку текущего пользователя или IconUser если аватарки нет.
 * Подписан на UsersController — перерендерится когда кеш загрузится.
 */
export function ProfileDockIcon({ size = 20 }: { size?: number; stroke?: number }) {
  const { user } = useAuthController();
  const controller = UsersController.getInstance();
  const usersState = useSyncExternalStore(
    controller.subscribe,
    controller.getSnapshot,
    controller.getSnapshot
  );

  if (!user) return <IconUser size={size} />;

  const cached = usersState.users.get(user.id);
  const rawUrl = cached?.avatarThumbUrl ?? null;
  const avatarSrc = rawUrl ? (rawUrl.startsWith('http') ? rawUrl : `${apiBaseUrl}${rawUrl}`) : null;

  if (!avatarSrc) return <IconUser size={size} />;

  return <Avatar src={avatarSrc} size={30} radius='xl' />;
}
